import React, { useCallback } from 'react';
import { Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { Breadcrumbs } from '../../../common/components/navigation';
import ClientList from '../list/ClientList';
import ClientCreation from '../creation/ClientCreation';
import ClientEdition from '../edition/ClientEdition';
import { useAbilityContext, useClientContext } from '../../../common/contexts/abilityContext';

const ClientPage = () => {
  const history = useHistory();
  const { path, url } = useRouteMatch();

  const returnToList = useCallback(() => {
    history.push(url);
  }, [history, url]);

  const handleRowClick = useCallback(
    ({ id }) => {
      history.push(`${url}/${id}`);
    },
    [history, url]
  );

  const redirectToEdition = useCallback((id) => history.push(`${url}/${id}`), [history, url]);

  const handleCreateClick = useCallback(() => history.push(`${url}/new`), [history, url]);

  const handleBackClick = useCallback(() => returnToList(), [returnToList]);

  const context = useAbilityContext();
  const clientId = useClientContext();

  if (context.cannot('create', 'client'))
    return (
      <>
        <Switch>
          <Route strict path={`${path}/:id`}>
            <ClientEdition onBackClick={handleBackClick} />
          </Route>

          <Redirect to={`${path}/${clientId}`} />
        </Switch>
      </>
    );

  return (
    <>
      <Breadcrumbs entityType="client" />

      <Switch>
        <Route strict path={`${path}/new`}>
          <ClientCreation onBackClick={handleBackClick} onCreatedSuccess={redirectToEdition} />
        </Route>

        <Route strict path={`${path}/:id`}>
          <ClientEdition onBackClick={handleBackClick} />
        </Route>

        <Route strict path={`${path}`}>
          <ClientList onRowClick={handleRowClick} onCreateClick={handleCreateClick} />
        </Route>
      </Switch>
    </>
  );
};

export default React.memo(ClientPage);
